import { Table, Container, Button, Row, Col, Input } from 'reactstrap';
import React, { useState } from 'react';
import { RiFileExcel2Line } from 'react-icons/ri'
import { AiOutlineFilePdf } from 'react-icons/ai'
import './Reports.css'

// pdfMake.vfs = pdfFonts.pdfMake.vfs;s

export function Report1912() {
    const [thYearSelected, setThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [othYearSelected, setOThYearSelected] = React.useState(new Date().getFullYear() + 543)
    const [Re1912data, setRe1912data] = useState([]);

    // pdfMake.fonts = {
    //     THSarabunNew: {
    //         normal: 'THSarabunNew.ttf',
    //         bold: 'THSarabunNew Bold.ttf',
    //         italics: 'THSarabunNew Italic.ttf',
    //         bolditalics: 'THSarabunNewn BoldItalic.ttf'
    //     },
    //     Roboto: {
    //         normal: 'Roboto-Regular.ttf',
    //         bold: 'Roboto-Medium.ttf',
    //         italics: 'Roboto-Italic.ttf',
    //         bolditalics: 'Roboto-MediumItalic.ttf'
    //     }
    // }

    async function getR1912() {
        const formData = new FormData();
        formData.append("thYear", thYearSelected);
        formData.append("othYear", othYearSelected);
        const res1912 = await fetch("/api/BorrowReports/getV1912", {
            method: 'POST',
            body: formData
        })
        const Re1912data = await res1912.json()
        setRe1912data(Re1912data.dataenum)
        // console.log(Re1912data)
    }

    const [Re1912yeardata, setRe1912yeardata] = React.useState([]);
    async function getR1912year() {
        const res = await fetch("/api/BorrowReports/getyear1912")
        const Re1912yeardata = await res.json()
        setRe1912yeardata(Re1912yeardata.dataenum)
        // console.log(Re1912yeardata)
    }



    const y2 = Re1912yeardata.filter(n => n.yearTh >= othYearSelected);
    const tableHeaders = y2.map((item, i) => (
        <>
            <th key={`header-${i}-1`} className='text-center'>
                ราย
            </th>
            <th key={`header-${i}-2`} className='text-center'>
                บาท
            </th>
          
        </>
    ));


    React.useEffect(() => {
        getR1912()
        getR1912year()
    }, [thYearSelected, othYearSelected]);


    const tableHeaders2 = Re1912data.map(n => n.count1);

    var hidecolumn = (tableHeaders2.every(n => n >= 1)) ? false : true;
    var hidecolumn1 = (tableHeaders2.every(n => n >= 2)) ? false : true;
    var hidecolumn2 = (tableHeaders2.every(n => n >= 3)) ? false : true;
    var hidecolumn3 = (tableHeaders2.every(n => n >= 4)) ? false : true;
    var hidecolumn4 = (tableHeaders2.every(n => n >= 5)) ? false : true;
    var hidecolumn5 = (tableHeaders2.every(n => n >= 6)) ? false : true;
    var hidecolumn6 = (tableHeaders2.every(n => n >= 7)) ? false : true;
    var hidecolumn7 = (tableHeaders2.every(n => n >= 8)) ? false : true;
    var hidecolumn8 = (tableHeaders2.every(n => n >= 9)) ? false : true;

   
    var col = (((thYearSelected - othYearSelected) + 2) * 2);

    var col1 = (col * 10);
 //var hidecolumn = false;
 //   var hidecolumn1 = false;
 //   var hidecolumn2 = false;
 //   var hidecolumn3 = false;
 //   var hidecolumn4 = false;
 //   var hidecolumn5 = false;
 //   var hidecolumn6 = false;
 //   var hidecolumn7 = false;
 //   var hidecolumn8 = false;
 //   if (othYearSelected > 2558 || thYearSelected < 2558) {
 //       var hidecolumn = true;
 //   }

 //   if (othYearSelected > 2559 || thYearSelected < 2559) {
 //       var hidecolumn1 = true;
 //   }
 //   if (othYearSelected > 2560 || thYearSelected < 2560) {
 //       var hidecolumn2 = true;
 //   }
 //   if (othYearSelected > 2561 || thYearSelected < 2561) {
 //       var hidecolumn3 = true;
 //   }
 //   if (othYearSelected > 2562 || thYearSelected < 2562) {
 //       var hidecolumn4 = true;
 //   }
 //   if (othYearSelected > 2563 || thYearSelected < 2563) {
 //       var hidecolumn5 = true;
 //   }
  //if (othYearSelected > 2564 || thYearSelected < 2564) {
  //      var hidecolumn6 = true;
  //  }
  //  if (othYearSelected > 2565 || thYearSelected < 2565) {
  //      var hidecolumn7 = true;
  //  }
  //  if (othYearSelected > 2566 || thYearSelected < 2566) {
  //      var hidecolumn8 = true;
  //  }

    // const PrintPDF = () => {
    //     var tablebody = [[{ text: 'ที่', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'หน่วยงาน', rowSpan: 3, fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'อนุมัติคำขอกู้', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}],
    //     [{}, {}, { text: 'รวม', colSpan: 2, fillColor: '#cccccc', bold: true, alignment: 'center' }, {}],
    //     [{}, {}, { text: 'ราย', fillColor: '#cccccc', bold: true, alignment: 'center' }, { text: 'บาท', fillColor: '#cccccc', bold: true, alignment: 'center' }]];
    //     Re1912data.forEach(function (item, i) {
    //         var rowdata = [{ text: i + 1, alignment: 'center' }, { text: item.site, alignment: 'left' }, { text: item.sum19, alignment: 'right' }, { text: item.sum20, alignment: 'right' }]
    //         tablebody.push(rowdata);
    //     });
    //     var docDefinition = {
    //         pageOrientation: 'landscape',
    //             content: [
    //             { text: 'สรุปผลการอนุมัติให้กู้ยืมเงิน และการชำระเงินคืนเงินคืนกองทุนพัฒนาฝีมือแรงงาน จำแนกตามรายชื่อสถานประกอบกิจการ', bold: true, alignment: 'center', fontSize: 18 },
    //             { text: 'ประจำปีงบประมาณ พ.ศ. ' + othYearSelected + ' ' + '-' + ' ' + thYearSelected, bold: true, alignment: 'center', fontSize: 16 },
    //             {
    //                 table: {
    //                     widths: ['auto', '*', '*', '*'],
    //                     body: tablebody
    //                 },
    //             }],

    //         defaultStyle: {
    //             font: 'THSarabunNew'
    //         }

    //     }
    //     pdfMake.createPdf(docDefinition).download('R1912')
    // }
  

    return (
        <Container>
            <div>
                {/* <div style={{ display: 'flex', paddingBottom: '10px', justifyContent: 'center' }}>
                    <h3 className='mt-1 text-center' >
                        ปีงบประมาณ พ.ศ. 
                    </h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re1912yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                    <h3 style={{ lineHeight: 'inherit' }}>ถึง</h3>
                    <Input
                        style={{ borderColor: "#130558", width: "33%", margin: "auto", }}
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div> */}
                <div className='d-flex justify-content-center align-items-center'>
                    <span className='header-select-year mx-3'>ปีงบประมาณ พ.ศ. </span>
                    <Input 
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="othYear"
                        name="othYear"
                        type="select"
                        value={othYearSelected}
                        onChange={(e) => {
                            setOThYearSelected(e.target.value)
                        }}
                    >
                        {Re1912yeardata.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    
                    </Input>
                    <span className='header-select-year mx-3'>ถึง</span>
                    <Input 
                        // className='report-select-year'
                        className="rounded-pill input-color w-25 text-center"
                        id="thYear"
                        name="thYear"
                        type="select"
                        value={thYearSelected}
                        onChange={(e) => {
                            setThYearSelected(e.target.value)
                        }}
                    >
                        {y2.map((item, i) => (
                            <option value={item.yearTh}>
                                {item.yearTh}
                            </option>

                        ))}
                    </Input>
                </div>

                {/* <Row>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn1" href={`api/BorrowReports/xlsxV1912?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>EXCEL</Button>
                        <Button className="btn2" href={`api/BorrowReports/pdfR1912?thYear=${thYearSelected}&othYear=${othYearSelected}`} download>PDF</Button>
                    </Col>
                </Row> */}
                <Row className='my-3'>
                    <Col className='d-flex justify-content-end'>
                        <Button className="btn border border-1 mx-1 btn-green" href={`api/BorrowReports/xlsxV1912?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><RiFileExcel2Line/> Export Excel</Button>
                        <Button className="btn border border-1 mx-1 btn-red" href={`api/BorrowReports/pdfR1912?thYear=${thYearSelected}&othYear=${othYearSelected}`} download><AiOutlineFilePdf/> Export PDF</Button>
                    </Col>
                </Row>
                <div className="report-wrapper">
                <Table className="styled-table" bordered striped hover>
                    <thead className='styles-thead'>
                        <tr>
                            <th rowSpan="3" className='text-center'>
                                ที่
                            </th>
                            <th rowSpan="3" className='text-center'>
                                หน่วยงาน
                            </th>
                            <th colSpan={col} className=' text-center'>
                                อนุมัติคำขอกู้
                            </th>

                        </tr>
                        <tr>
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn}>*/}
                            {/*    ปีงบประมาณ 2558*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn1}>*/}
                            {/*    ปีงบประมาณ 2559*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn2}>*/}
                            {/*    ปีงบประมาณ 2560*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn3}>*/}
                            {/*    ปีงบประมาณ 2561*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn4}>*/}
                            {/*    ปีงบประมาณ 2562*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn5}>*/}
                            {/*    ปีงบประมาณ 2563*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn6}>*/}
                            {/*    ปีงบประมาณ 2564*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn7}>*/}
                            {/*    ปีงบประมาณ 2565*/}
                            {/*</th>*/}
                            {/*<th colSpan="2" className='text-center' hidden={hidecolumn8}>*/}
                            {/*    ปีงบประมาณ 2566*/}
                                {/*</th>*/}
                                {y2.map((item, i) => (
                                    <th colSpan="2" className='text-center' >
                                        ปีงบประมาณ {item.yearTh}
                                    </th>

                                ))}
                            <th colSpan="2" className='text-center'>
                                รวม
                            </th>
                        </tr>
                        <tr> 
                            {/*<th className='text-center' hidden={hidecolumn}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn1}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn1}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn2}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn2}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn3}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn3}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn4}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn4}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn5}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn5}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn6}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn6}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn7}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn7}>*/}
                            {/*    บาท*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn8}>*/}
                            {/*    ราย*/}
                            {/*</th>*/}
                            {/*<th className='text-center' hidden={hidecolumn8}>*/}
                            {/*    บาท*/}
                                {/*</th>*/}
                                {tableHeaders}
                            <th className='text-center' >
                                ราย
                            </th>
                            <th className='text-center' >
                                บาท
                            </th>

                        </tr>
                    </thead>
                        <tbody>
                        {Re1912data.length > 0 && Re1912data.map((item, i) => (
                        <tr >
                            <th scope="row" className='text-center'>
                                {i + 1}
                            </th>
                            <td className='text-start' >
                                {item.site}
                            </td>
                            <td className='text-end' hidden={hidecolumn}>
                                {item.sum1}
                            </td>
                            <td className='text-end' hidden={hidecolumn}>
                                {item.sum2}
                            </td>
                            <td className='text-end' hidden={hidecolumn1}>
                                {item.sum3}
                            </td>
                            <td className='text-end' hidden={hidecolumn1}>
                                {item.sum4}
                            </td>
                            <td className='text-end' hidden={hidecolumn2}>
                                {item.sum5}
                            </td>
                            <td className='text-end' hidden={hidecolumn2}>
                                {item.sum6}
                            </td>
                            <td className='text-end' hidden={hidecolumn3}>
                                {item.sum7}
                            </td>
                            <td className='text-end' hidden={hidecolumn3}>
                                {item.sum8}
                            </td>
                            <td className='text-end' hidden={hidecolumn4}>
                                {item.sum9}
                            </td>
                            <td className='text-end' hidden={hidecolumn4}>
                                {item.sum10}
                            </td>
                            <td className='text-end' hidden={hidecolumn5}>
                                {item.sum11}
                            </td>
                            <td className='text-end' hidden={hidecolumn5}>
                                {item.sum12}
                            </td>
                            <td className='text-end' hidden={hidecolumn6}>
                                {item.sum13}
                            </td>
                            <td className='text-end' hidden={hidecolumn6}>
                                {item.sum14}
                            </td>
                            <td className='text-end' hidden={hidecolumn7}>
                                {item.sum15}
                            </td>
                            <td className='text-end' hidden={hidecolumn7}>
                                {item.sum16}
                            </td>
                            <td className='text-end' hidden={hidecolumn8}>
                                {item.sum17}
                            </td>
                            <td className='text-end' hidden={hidecolumn8}>
                                {item.sum18}
                            </td>
                            <td className='text-end'>
                                {item.sum19}
                            </td>
                            <td className='text-end'>
                                {item.sum20}
                            </td>
                    
                          
                            
                            </tr>
                        )) || <tr><td colSpan={col1} rowSpan="6" className='text-center'>ไม่มีข้อมูลในระบบ</td></tr>}
                    </tbody>
                </Table>

                </div>
            </div>

        </Container>
    );

}